<template>
  <div class="panorama-spot__build build-panorama-spot">
    <div class="build-panorama-spot__container">
      <div class="build-panorama-spot__label">
        {{ name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanoramaRoadSpot',
  props: {
    name: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.build-panorama-spot__container:after,
.build-panorama-spot__container:before {
   content: '';
   border: solid transparent;
   position: absolute;
   left: 50%;
   margin-left: -12px;
   bottom: -24px;
   width: 0;
}
.build-panorama-spot__container:before {
   border-top-color: #000;
   border-width: 12px;
}
.build-panorama-spot__container:after {
   border-top-color: var(--panorama-background-color);
   border-width: 13px;
   margin-left: -13px;
}
.build-panorama-spot {
  position: relative;
  &__container {
    position: relative;
    background: var(--panorama-background-color);
    box-shadow: 0 0 0 0.5px #000;
    padding: 7px 11px 5px 11px;
    border-radius: 4px;
    box-sizing: border-box;
    @media screen and (min-width: 1024px) {
      border-radius: 8px;
    }
  }
  &__label {
    font-family: var(--panorama-first-font);
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    text-align: center;
    color: var(--panorama-text-color);
    @media screen and (min-width: 1024px) {
      font-size: 16px;
    }
  }
}
</style>
